/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';

import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,

} from 'mdb-react-ui-kit';

import { isTokenPresent } from '../utils/auth';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiGLPIRoutes from '../utils/hooks/apiGLPIRoutes';
import apiRoutes from '../utils/hooks/apiRoutes';
import src from "../assets/img/logoSI.webp"
import InputField from './InputField';
import Button from './Button';
import PopUp from './PopUp';
import UploadSignedDocuments from './UploadSignedDocuments';

import "../style/css/editdocuments.css"

import DocumentData from '../utils/Interface/DocumentData';

interface EditDocumentProps {
  documentId: number; // Ajoutez la prop documentId
}

function EditDocument({ documentId }: EditDocumentProps) {

  const [dataOne, setDataOne] = useState<DocumentData | null>(null);
  const [documentSelectedName, setDocumentSelectedName] = useState<string>('')
  const [documentSelectedUserId, setDocumentSelectedUserId] = useState<number>()
  const [documentSelectedUserName, setDocumentSelectedUserName] = useState<string>('')  
  const [documentSelectedModelDocName, setDocumentSelectedModelDocName] = useState<string>('')
  const { specialToken } = useSpecialToken();
  const[optXlModal, setOptXlModal] = useState(false);


  useEffect(() => {
    if (!isTokenPresent()) {
      window.location.href = '/'; // Redirection vers la page de connexion
      return;
    }

    if (documentId) {
      fetchDataOne();
    }
  }, [documentId, specialToken]);

  const fetchDataOne = async (): Promise<void> => {

    try {
      if (!documentId) {
        throw new Error('ID de document non valide');
      }
  
      const getOneUrl = apiRoutes.documentsGetOne.replace(':id', `${documentId}`);
  
      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }
  
      const headers = {
        'Content-Type': 'application/json',
        'special-token': specialToken
      };
  
      const response = await fetch(getOneUrl, { headers });
  
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }
      const jsonDataOne: DocumentData = await response.json();


      setDataOne(jsonDataOne);
      setDocumentSelectedName(jsonDataOne.document_name);
      setDocumentSelectedUserId(jsonDataOne.user_id);
      setDocumentSelectedUserName(jsonDataOne.user_name);
      setDocumentSelectedModelDocName(jsonDataOne.documents_modeles_name);
  
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
    
  };
  const handleDelete = async () => {

    try {

      if (!documentId) {
        throw new Error('Aucun modèle sélectionné.');
      }

      let specialTokenDev = localStorage.getItem('specialTokenDev');
      let specialTokenSuperAdmin = localStorage.getItem('specialTokenSuperAdmin');
      let specialTokenAdmin = localStorage.getItem('specialTokenAdmin');
      let specialToken;

      if (specialTokenDev) {
        specialToken = specialTokenDev;
      } else if (specialTokenSuperAdmin) {
        specialToken = specialTokenSuperAdmin;
      } else if (specialTokenAdmin) {
        specialToken = specialTokenAdmin;
      } else {
        console.error('Aucun token spécial trouvé.');
      }
      
      if (specialToken) {
        if (!documentId) {
          throw new Error('ID de document non valide');
        }
    
        const deleteUrl = apiRoutes.documentsDelete.replace(':id', `${documentId}`);
    
        const response = await fetch(deleteUrl, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'special-token': specialToken
          }
        });
  
        if (!response.ok) {
          throw new Error('Erreur lors de la suppression du modèle');
        }

        alert("Document supprimé avec succès")
  
        fetchDataOne(); 

        window.location.reload(); 
        
      } else {
        console.error('Aucun token spécial trouvé.');
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du modèle :', error);
    }
  };
  
  const handleSaveInput = async () => {

    try {

      if (!documentId || !dataOne) {
        throw new Error('Aucun document sélectionné ou données manquantes.');
      }

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const currentDate = new Date().toISOString();

      if (!documentId) {
        throw new Error('ID de document non valide');
      }
      const putUrl = apiRoutes.documentsPut.replace(':id', `${documentId}`);

      const response = await fetch(putUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
        body: JSON.stringify({
          name: documentSelectedName, // Vous pouvez ajouter d'autres champs à mettre à jour ici
          date_mod: currentDate, // Ajoutez la date de modification
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la mise à jour du document');
      }

      alert("Document Modifié avec succès !")

      fetchDataOne();

      window.location.reload(); 

    } catch (error) {
      console.error('Erreur lors de la mise à jour du document :', error);
    }

  };

  const handleDownload = async () => {

    try {
      const token = localStorage.getItem('sessionToken');
  
      if (!token) {
        throw new Error('Token not found in local storage');
      }
  
      if (!documentId) {
        throw new Error('ID de document non valide');
      }

      const getOneUrlGLPI = apiGLPIRoutes.documentGetOne.replace(':documentId', `${documentId}`);
  
      const requestOptions = {
        method: 'GET',
        headers: {
          'Accept': 'application/octet-stream',
          'Session-Token': token,
          'Content-Type': 'application/json',
        },
      };
    
      const response = await fetch(getOneUrlGLPI, requestOptions);
    
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }
  
      const blob = await response.blob();
  
      const url = window.URL.createObjectURL(blob);
  
      const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'essai.pdf'); 
            document.body.appendChild(link);
  
      link.click();
  
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  };
  
  const toggleOpenxl = () => setOptXlModal(!optXlModal);

  const labels = [{ title: 'Nom du document' }];

  return (
    <div className='modaleditdoc'>

      <div className='modaleditdoc__box1'>

        <div className='modaleditdoc__box1__container'>
  
          <div className='modaleditdoc__box1__container__options'>

            <div className='modaleditdoc__box1__container__options__pdf'>

              <img src={src} alt='pdf' />

              <InputField
              labels={labels}
              initialValue={[documentSelectedName]}
              onChange={newValue => setDocumentSelectedName(newValue[0])} />

            </div>

            <div className='modaleditdoc__box1__container__options__btns'>

              <Button btnName={'Télécharger'} onClick={handleDownload} disable={false}/>

              <Button btnName={'Sauvegarder'} onClick={handleSaveInput} disable={false} />

              <Button btnName={'+ Document signé'} onClick={toggleOpenxl} disable={false}/>

              <MDBModal open={optXlModal} tabIndex='-1' onClose={() => setOptXlModal(false)}>
                <MDBModalDialog  size='xl'>
                 <MDBModalContent id="contentd">
                    <MDBModalHeader>
                      <MDBModalTitle>Télécharger le nouveau document signé </MDBModalTitle>
                      <MDBBtn 
                      className='btn-close' 
                      color='none' 
                      onClick={toggleOpenxl}>
                      </MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody> 
                      <UploadSignedDocuments 
                        documentId={documentId} 
                        user_name={documentSelectedUserName} 
                        user_id={documentSelectedUserId ||0} 
                        modelDocName={documentSelectedModelDocName}/>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              <PopUp onDeleteClick={handleDelete}/>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default EditDocument;


